import { addError } from '../redux/actions/error.action';
import translations from '../content/Error/error.json';
import { getTranslations } from './getTranslations';

// Вспомогательная функция для чтения Blob как текста
const readBlobAsText = (blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result); // Когда чтение завершено, возвращаем результат
    reader.onerror = reject; // В случае ошибки, отклоняем промис
    reader.readAsText(blob); // Читаем Blob как текст
  });
};

export const handleRequestError = async (error, dispatch) => {
  const t = getTranslations(translations);
  let message = t?.unexpectedError || 'Возникла непредвиденная ошибка, обратитесь к администратору системы.';
  if (error?.response?.data instanceof Blob) {
    try {
      const errorText = await readBlobAsText(error?.response?.data);
      const parsed = JSON.parse(errorText);
      message = parsed?.message || parsed?.error || message;
    } catch (parseError) {
      console.warn('Ошибка при чтении или парсинге тела ошибки:', parseError);
    }
  } else if (typeof error.response?.data === 'object') {
    message = error.response.data?.message || error.response.data?.error || message;
  }

  dispatch(addError({ error: message }));
};
